<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="box mt-2">
          <div class="heading">
            <h3>管理者</h3>
          </div>
          <table v-if="page" class="table table-sm table-list table-hover mt-2">
            <thead>
            <tr>
              <th>名前</th>
              <th>メールアドレス</th>
              <th>ステータス</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="admin in page.items" @click="moveToShow(admin.id)" class="pointer">
              <td>{{ admin.name }}</td>
              <td>{{ admin.email }}</td>
              <td class="text-center">{{ admin.status.description }}</td>
            </tr>
            </tbody>
          </table>
          <Pagination v-if="page" :page="page" class="mt-3" v-model="filter" @change="changePage"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import {getCurrentAdmin} from '../../../api/admin/AuthApi';
import usePagination from '../../../composables/usePagination';
import useOffcanvas from '../../../composables/useOffcanvas';
import useFlashMessage from '../../../composables/useFlashMessage';
import Pagination from '../../../components/Pagination.vue';
import AdminFilter from '../../../filters/admin/AdminFilter';

const {errorMessage} = useFlashMessage();

const router = useRouter();

const filter = ref(new AdminFilter());
const currentAdmin = ref();

const {page, fetch, changePage} = usePagination(filter.value);

onMounted(async () => {
  currentAdmin.value = await getCurrentAdmin();
});

/**
 * 詳細画面に遷移
 *
 * @param adminId
 */
const moveToShow = adminId => {
  router.push({name: 'admin.admins.show', params: {id: adminId}});
};
</script>
